import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  display: "flex",
};

export const sideBarContainer: CSSProperties = {
  display: "flex",
  position: "relative",
  width: 300,
  minWidth: 300,
  height: "100%",
  "@media (max-width: 768px)": {
    display: "none",
    width: "unset",
    flex: 1,
  },
};

export const absoluteSideBarContainer: CSSProperties = {
  position: "absolute",
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderStyle: "solid",
  overflow: "auto",
  backgroundColor: greys.white,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",

  "&::-webkit-scrollbar-thumb": {
    visibility: "hidden",
  },

  "&:hover::-webkit-scrollbar-thumb": {
    visibility: "visible",
  },
};

export const event: CSSProperties = {
  margin: "0 auto",
  maxWidth: 750,
  width: "100%",

  "@media (max-width: 768px)": {
    margin: 0,
  },
};

export const page: CSSProperties = {
  flex: 1,
  overflow: "auto",
  "@media (max-width: 768px)": {
    display: "none",
  },
};

export const pageContent: CSSProperties = {
  padding: 20,

  "@media (max-width: 768px)": {
    padding: 0,
  },
};

export const styles = {
  container,
  page,
  pageContent,
  sideBarContainer,
  absoluteSideBarContainer,
  event,
};
